import { router } from '@inertiajs/react';
import { useEffect, useState } from 'react';

type Product = {
    id: number;
    name: string;
    price: number;
    price_list: string;

    product_type: string;
    product_vendor: string;
    product_model: string;

    product_data: string;
};

type Props = {
    product: Product;
};

export default function ProductRow({ product: initialProduct }: Props) {

    const [product, setProduct] = useState(initialProduct);
    const [expanded, setExpanded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [productData, setProductData] = useState<any>(null);

    useEffect(() => {
        setProduct(initialProduct);
    }, [initialProduct]);

    const onDelete = () => {
        if (!confirm(`Удалить "${product.name}"?`)) return;

        router.delete(`/products/${product.id}`, { preserveScroll: true });
    };

    const onLoadData = async () => {
        if (expanded) {
            setExpanded(false);
            return;
        }

        if (!productData) {
            setLoading(true);

            const response = await fetch(`/products/${product.id}/data`);
            const json = await response.json();

            setProductData(json.product_data);
            setLoading(false);
        }

        setExpanded(true);
    };

    const onEnrichData = async () => {
        setLoading(true);

        const response = await fetch(`/products/${product.id}/enrich`);
        const json = await response.json();

        setProduct(json.product);
        setProductData(json.product.product_data);
        setLoading(false);

        setExpanded(true);
    };

    return (
        <>
            <tr
                className={`border-t border-sidebar-border/50 transition-colors
                ${product.product_data || productData ? 'bg-emerald-50 hover:bg-emerald-100/60' : 'hover:bg-muted/30'}
            `}>
                <td className="px-6 py-4 text-muted-foreground">{product.id}</td>

                <td className="px-6 py-4 font-medium">
                    <div className="flex flex-wrap items-center gap-2">

                        <span className="text-gray-900 w-full">
                            {product.name}
                        </span>

                        {product.product_type && (
                            <span className="inline-flex items-center rounded-md bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 ring-1 ring-emerald-200">
                            {product.product_type}
                        </span>
                        )}

                        {product.product_vendor && (
                            <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700 ring-1 ring-blue-200">
                                {product.product_vendor}
                            </span>
                        )}

                        {product.product_model && (
                            <span className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-700 ring-1 ring-indigo-200">
                                {product.product_model}
                            </span>
                        )}
                    </div>
                </td>


                <td className="px-6 py-4 text-right whitespace-nowrap">
                    {product.price.toLocaleString('ru-RU')} ₽
                </td>

                <td className="px-6 py-4 whitespace-nowrap">
                    {product.price_list}
                </td>

                <td className="px-6 py-4 text-right">
                    <div className="flex justify-end gap-2">
                        {(productData || product.product_data) && (
                            <button
                                type="button"
                                onClick={onLoadData}
                                className="inline-flex items-center rounded-lg border px-3 py-2 text-sm hover:bg-muted/40 transition-colors"
                            >
                                {expanded ? 'Скрыть' : 'Данные'}
                            </button>
                        )}

                        <button
                            type="button"
                            onClick={onEnrichData}
                            className="inline-flex items-center rounded-lg border px-3 py-2 text-sm hover:bg-muted/40 transition-colors"
                        >
                            Проанализировать
                        </button>

                        <button
                            type="button"
                            onClick={onDelete}
                            className="inline-flex items-center rounded-lg border border-sidebar-border/60 px-3 py-2 text-sm hover:bg-muted/40 transition-colors"
                        >
                            Удалить
                        </button>
                    </div>
                </td>

            </tr>

            {expanded && (
                <tr className="bg-muted/20">
                    <td colSpan={4} className="px-6 py-4">
                        {loading ? (
                            <div className="text-sm text-muted-foreground">Загрузка...</div>
                        ) : (
                            <pre className="text-xs bg-background p-4 rounded-xl overflow-x-auto border">
                                {JSON.stringify(productData, null, 2)}
                            </pre>
                        )}
                    </td>
                </tr>
            )}
        </>
    );
}
